import { initializeSdk, logEvent, updateUser } from '@eventbrite/statsig';
import { Dispatch } from 'redux';
import { getInitialStatsigCustomUserConfig } from '../selectors/app';
import { isStatsigFreeTrialEnabledForInterstitialLogin } from '../selectors/statsig';
import {
    getLoginFromCheckoutPage,
    getUserId,
    isUserLoggedIn,
} from '../selectors/user';
import { CheckoutState } from '../state';
import { AppNamespace } from '../state/app';
import { Experiment } from '../state/statsig';

export const initializeStatsigSdk = async (app: AppNamespace) => {
    await initializeSdk({
        user: getInitialStatsigCustomUserConfig(app),
    });
};

export const updateExperimentUser =
    () => async (_: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        await updateUser({ user: { userID: getUserId(getState()) } });
    };

export const logLoginInterstitialEvent =
    (eventName: string) =>
    (_: Dispatch<CheckoutState>, getState: () => CheckoutState) =>
        logEvent(eventName, null, {
            isInterstitialStep: `${!getLoginFromCheckoutPage(getState())}`,
        });

export const isLoginInterstitialEnabled =
    () => async (_: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        const state = getState();
        if (
            isUserLoggedIn(state) ||
            !isStatsigFreeTrialEnabledForInterstitialLogin(state)
        ) {
            return false;
        }

        // This experiment is not currently in use and we're temporarily deactivating it until the 2nd iteration arrives
        return false;
    };

export enum StatsigActionType {
    saveExperimentData = 'saveExperimentData',
}

export interface SaveExperimentDataAction {
    type: StatsigActionType.saveExperimentData;
    payload: Experiment;
}

export const saveExperimentDataAction = (
    experiment: Experiment,
): SaveExperimentDataAction => ({
    type: StatsigActionType.saveExperimentData,
    payload: experiment,
});

export type StatsigAction = SaveExperimentDataAction;
